import React, { useState } from 'react';
import { FaStar } from 'react-icons/fa';
import ReviewService from './reviewservice';
import './ratingstar.css'


const colors = {
    yellow: "#ffc107",
    grey: "#e4e5e9"
};

function RatingStar() {
    const [rating, setRating] = useState(null);
    const [hoverRating, setHoverRating] = useState(undefined);
    const stars = Array(10).fill(0);

    const handleClick = value => {
        setRating(value)
    };
    const handleMouseOver = newHoverValue => {
        setHoverRating(newHoverValue)
    };
    const handleMouseOut = () => {
        setHoverRating(undefined)
    };

    return (
        <div className="container-review">
            <div className="image">
                <img src="https://i.pinimg.com/564x/f1/f4/59/f1f459aa95002c3c60b8d683774a2f5e.jpg" alt="meow" width="50" height="50" />
            </div>
            <div className="review-items">
                <p className="username">erdia</p>
                <div className="stars">
                    {stars.map((star, index) => {
                        return (
                            <FaStar className="stars"
                                key={index}
                                size={30}
                                value={rating}
                                onChange={(event) => setRating(event.target.value)}
                                onClick={() => handleClick(index + 1)}
                                onMouseOver={() => handleMouseOver(index + 1)}
                                onMouseOut={handleMouseOut}
                                color={(hoverRating || rating) > index ? colors.yellow : colors.grey}
                            />
                        )
                    })}
                </div>
                <ReviewService />
            </div>
        </div>


    )
}
export default RatingStar;